var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C5.5 2 8.54107 3.52053 12.966 6.89305C14.0082 7.68743 13.9651 9.26197 12.8673 9.9777C9.15676 12.397 7.99135 12.2178 5 13.5L5.5 2Z",
    stroke: "#EFEFF4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 2 8.65635 5.57243 11.6993 7.43386C12.4169 7.87281 12.3552 9.01572 11.5822 9.34755C7.15031 11.2501 4.07476 12.1821 1 13.5L3 2Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutRight);
export default __webpack_public_path__ + "static/media/CalloutRight.fa036d5968d36913ffe3cdfe88388431.svg";
export { ForwardRef as ReactComponent };